import { lastPoint } from './helper/lastPoint'
import { rotatePath } from './helper/rotatePath'
import { translatePath } from './helper/translatePath'

export const buildOutline = (side1, side2, shift = [0, 0]) => {
  const buildSideA = (a, b) => translatePath(a, lastPoint(b))
  const buildSideB = (a, b) => buildSideA(rotatePath(a, 180), b)
  const sideB = buildSideA(side2, side1)
  const sideC = buildSideB(side1, sideB)
  return translatePath(
    side1.concat(sideB, sideC, buildSideB(side2, sideC)),
    shift
  )
}
